// extracted by mini-css-extract-plugin
export var fileUpload = "_ir-1";
export var modalButton = "_ir-0";